import LabServiceModel from "@/models/LabServiceModel";

export default class SampleStatusModel extends LabServiceModel {

  modelName() {
    return 'sample-status';
  }

  defaults() {
    return {
      id: null,
      status: null,
      description: null,
      order: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      sample_status_logs: [],
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      status: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  icon() {
    return this.getIcon();
  }

  getIcon() {
    switch (this.status) {
      default:
        return 'shovel';
    }
  }

  getVariant() {
    switch (this.status) {
      default:
        return 'dark';
    }
  }

}
